import { useCheckAdmin } from './useCheckAdmin';

/**
 * @returns `true` if the {@link User} can use billing. May returns `undefined` if user is not logged in yet.
 */
export function useCanUseBilling(): boolean | undefined {
  return useCheckAdmin();
}
